import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import React from "react";
import { AdviceLogin } from "../../AdviceLogin";
import { AkaFamilyAccidentLogin } from "../../AkaFamilyAccidentLogin";
import { CabinLogin } from "../../CabinLogin";
import { CarLogin } from "../../CarLogin";
import { ChildLogin } from "../../ChildLogin";
import { HealthLogin } from "../../HealthLogin";
import { HouseLogin } from "../../HouseLogin";
import { PregnantAndNewbornLogin } from "../../PregnantAndNewbornLogin";
import { ProductLogin } from "../../ProductLogin";

interface ProductLoginSwitchProps {
  readonly productBackendName: ProductBackendName;
}

export const ProductLoginSwitch = ({
  productBackendName,
}: ProductLoginSwitchProps): React.ReactElement => {
  switch (productBackendName) {
    case ProductBackendName.ADVICE:
      return <AdviceLogin />;
    case ProductBackendName.AKA_FAMILY_ACCIDENT:
      return <AkaFamilyAccidentLogin productBackendName={productBackendName} />;
    case ProductBackendName.PREGNANT_AND_NEWBORN:
      return (
        <PregnantAndNewbornLogin productBackendName={productBackendName} />
      );
    case ProductBackendName.HOUSE:
      return <HouseLogin productBackendName={productBackendName} />;
    case ProductBackendName.CABIN:
      return <CabinLogin productBackendName={productBackendName} />;
    case ProductBackendName.CAR:
      return <CarLogin />;
    case ProductBackendName.HEALTH:
    case ProductBackendName.AKA_HEALTH:
      return <HealthLogin productBackendName={productBackendName} />;
    case ProductBackendName.CHILD:
      return <ChildLogin productBackendName={productBackendName} />;
    default:
      return <ProductLogin productBackendName={productBackendName} />;
  }
};
